<div>
  <h1>{{ 'ORGANISE_WITH_US' | translate }}</h1>

  <div *ngFor="let organiser of (organisers$ | async); trackBy: trackById">
    <app-organiser-preview [organiser]="organiser"></app-organiser-preview>
  </div>
</div>